const ERRORS = {
    ERROR_INESPERADO: "Ha ocurrido un error inesperado",
}

export default ERRORS